import mails from "./mail";
import mailThreads from "./mailThread";
import onboarding from "./onboarding";
import uiState from "./uiState";
import timeData from "./timer";
import calls from "./call";
import actors from "./actors";
import meetings from "./meeting";
import callSequence from "./callSequence";
import tutorial from "./tutorial";
import { combineReducers } from "redux";

export default combineReducers({
	mails,
	mailThreads,
	calls,
	meetings,
	callSequence,
	actors,
	onboarding,
	uiState,
	timeData,
	tutorial
});



// WEBPACK FOOTER //
// /src/reducers/index.js